import { trigger, transition, style, animate } from '@angular/animations';

export const dropdownAnimation = trigger('dropdownAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'scale(0.3)',
    }),
    animate('300ms cubic-bezier(0.175, 0.885, 0.32, 1.275)', style({
      opacity: 1,
      transform: 'scale(1)',
    })),
  ]),
  transition(':leave', [
    animate('150ms ease', style({
      opacity: 0,
      transform: 'scale(0.85)',
    })),
  ]),
]);
